module.exports = [{"name":"告警时间","code":"0"},{"name":"过车时间","code":"1"}]


//////////////////
// WEBPACK FOOTER
// ./static/json/dictionary/timeType2.json
// module id = fbY6
// module chunks = 11